import React, { useEffect, useRef } from "react";
import "./styles/MainBanner.scss";
import { Trans, useTranslation } from "react-i18next";

const MainBanner = () => {
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    videoRef.current?.play();
  }, []);
  return (
    <>
      <div className="main_banner_wrap">
        <div className="video_wrap">
          <video ref={videoRef} autoPlay muted loop>
            <source src="/video/main_vedio.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="txt_wrap">
          <h2>{t("home.mainBanner.title")}</h2>
          <h3>
            <Trans i18nKey="home.mainBanner.sub" components={{ bar: <span className="bar" /> }} />
          </h3>
          <p>
            <Trans i18nKey="home.mainBanner.description" components={{ bold: <span className="bold" /> }} />
          </p>
          <ul>
            <li>{t("home.mainBanner.li_1")}</li>
            <li>{t("home.mainBanner.li_2")}</li>
            <li>{t("home.mainBanner.li_3")}</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default MainBanner;
